'use client';

import { Suspense } from 'react';

import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';
import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';

import type { SlotProps } from '../Base/Slot.client';
import { Slot } from '../Base/Slot.client';
import { ServiceSlotMenuList } from '../Base/ServiceSlotMenuList';
import { useServiceLink } from '../../shared/useServiceLink';

/** Service slot with list of helpers in popover */
export const ServiceSlot = (props: Pick<SlotProps, 'priority'>) => {
  const { href, label } = useServiceLink();
  const { isDesktop } = useDeviceType();

  return (
    <>
      {isDesktop && (
        <Slot
          {...props}
          icon={<span className="icon-emp-service size-4" />}
          title={label}
          href={href}
        >
          <ErrorBoundary>
            <Suspense>
              <ServiceSlotMenuList />
            </Suspense>
          </ErrorBoundary>
        </Slot>
      )}
    </>
  );
};
